import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "#000",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "clip-path": "url(#i1617473413__a)"
    }, [
      _createElementVNode("path", { d: "M1.717 15.583A10.573 10.573 0 1 0 21.18 7.312a10.573 10.573 0 0 0-19.462 8.271M18.925 18.923l8.2 8.202" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i1617473413__a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h28v28H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }